/* jshint esversion: 6 */
/* jshint ignore:start */
import { useContext, useEffect, useRef, useState } from 'react';
import { IoIosArrowBack, IoIosArrowForward } from "react-icons/io";
import { FaStar } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { RiVerifiedBadgeFill } from "react-icons/ri";
import Slider from "react-slick";
import axios from 'axios';
import { MyContext } from '../../Context/MyProvider';
import { showToast } from '../../showTost';
import briefcaseicon from "../../assets/Icon/briefcase.svg";
import { useTranslation } from 'react-i18next';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Zoom from "yet-another-react-lightbox/plugins/zoom";
import Loading from '../Loading';
import secureLocalStorage from "react-secure-storage";
const CustomPrevArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#0d4047] p-[3px] rounded-[50px] absolute z-10 right-[40px] -top-[32px] transform -translate-y-1/2 cursor-pointer"
    >
        <MdChevronLeft color="#fff" size={20} />
    </div>
);

const CustomNextArrow = ({ onClick }) => (
    <div
        onClick={onClick}
        className="bg-[#0d4047] p-[3px] rounded-[50px] absolute z-10 right-[0px] -top-[32px] transform -translate-y-1/2 cursor-pointer"
    >
        <MdChevronRight color="#fff" size={20} />
    </div>
);

const DocProfile = () => {

    const { t } = useTranslation();

    const { ApiBaseUrl, ImgBaseUrl, setIsLoginShow } = useContext(MyContext);

    const site_currency = secureLocalStorage.getItem("currency");
    const currency = site_currency ? site_currency : "$";

    const [loading, setLoading] = useState(true);
    const [selectBtn, setSelectBtn] = useState(1);
    const [expandedIndex, setExpandedIndex] = useState("");
    const [faqList, setFaqList] = useState([]);
    const [isShow, setIsShow] = useState(false);
    const [selectBtn1, setSelectBtn1] = useState(0);
    const [serviceid, setServiceId] = useState();
    const [dateList, setDateList] = useState([]);
    const [dateSelect, setDateSelect] = useState();
    const [timeLiat, setTimeList] = useState();
    const [timeSelect, setTimeSelect] = useState("");
    const [doctorData, setDoctorData] = useState();
    const [reviews, setReviews] = useState([]);
    const [awards, setAwards] = useState([]);
    const [photos, setPhotos] = useState([]);
    const [photosIndex, setphotosIndex] = useState("");
    const [showLightBox, setShowLightBox] = useState(false);
    const [service, setService] = useState([]);
    const [showType, setShowType] = useState();
    const [hospitalList, setHospitalList] = useState([]);
    const [selectHospitalId, setSelectHospitalId] = useState();
    const [timeLoading, setTimeLoading] = useState(false);
    const [dateType, setDateType] = useState();
    const [showTypePrice, setShowTypePrice] = useState("");
    const [isFav, setIsFav] = useState("");

    const AboutRef = useRef(null);
    const ReviewRef = useRef(null);
    const AwardsRef = useRef(null);
    const PhotosRef = useRef(null);
    const FAQRef = useRef(null);
    const CancelPolicyRef = useRef(null);

    const Data = sessionStorage.getItem("Docprofile");
    if (Data) {
        var { title, path, pagename, id, department_id } = JSON.parse(Data);
    }

    const navigate = useNavigate();

    const scrollToSection = (index, ref) => {
        if (ref && ref.current) {
            ref.current.scrollIntoView({ behavior: 'smooth' });
        }
        setSelectBtn(index);
    };

    const handleChange = (index) => {
        const Index = expandedIndex === index ? "" : index;
        setExpandedIndex(Index);
    };

    const settingsday = {
        arrows: false,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            { breakpoint: 995, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 900, settings: { slidesToShow: 3, slidesToScroll: 1 } },
            { breakpoint: 530, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        ],
    };

    const settingstime = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 500,
        slidesToShow: 6,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 995, settings: { slidesToShow: 6, slidesToScroll: 1 } },
            { breakpoint: 900, settings: { slidesToShow: 5, slidesToScroll: 1 } },
            { breakpoint: 580, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 430, settings: { slidesToShow: 4, slidesToScroll: 1 } },
            { breakpoint: 380, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        ],
    };

    const settingsawards = {
        arrows: true,
        dots: false,
        infinite: false,
        speed: 1000,
        slidesToShow: 7,
        slidesToScroll: 1,
        nextArrow: <CustomNextArrow />,
        prevArrow: <CustomPrevArrow />,
        responsive: [
            { breakpoint: 1200, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
            { breakpoint: 770, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    };

    useEffect(() => {
        fetchData();
    }, [Data]);

    useEffect(() => {
        loading
            ? document.body.style.overflow = "hidden"
            : document.body.style.overflow = "auto"
    }, [loading]);

    const fetchData = () => {
        const Userid = secureLocalStorage.getItem("Userid") || "0";
        setLoading(true);

        if (Userid) {

            axios.post(`${ApiBaseUrl}/customer/doctor_detail`, { department_id: department_id, d_id: id, id: Userid })
                .then((res) => {
                    // console.log("doctor_detail", res.data);
                    const { ResponseCode, doctor, review_data, award_data, gallery_list, faq_data, alldate, ndatelist, hospital_list, dep_sub_ser_list } = res.data;
                    if (ResponseCode === 200) {
                        setLoading(false);
                        setDoctorData(doctor);
                        setReviews(review_data);
                        setAwards(award_data);
                        setFaqList(faq_data);
                        setDateList(alldate);
                        setDateSelect(alldate[0].date);
                        setTimeList(ndatelist);
                        setHospitalList(hospital_list);
                        setIsFav(doctor.tot_favorite);
                        setService(dep_sub_ser_list);
                        setServiceId(dep_sub_ser_list[0]);
                        setShowType(dep_sub_ser_list[0].show_type);
                        const index = dep_sub_ser_list[0].show_type === "2" ? 1 : 0;
                        setSelectBtn1(index);
                        const Photos = gallery_list;
                        const newPhotos = Photos.map(photo => ({ src: ImgBaseUrl + photo.image }));
                        setPhotos(newPhotos);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        }
    }

    useEffect(() => {
        setTimeSelect("");
        setShowTypePrice("");
        HandleDateSelect(dateSelect);
    }, [serviceid]);

    useEffect(() => {
        if (!timeSelect) return;
        const selectedService = service.find(item => item.id === serviceid.id);
        const ShowTypePrice = selectedService
            ? (selectBtn1 === 0 ? selectedService.client_visit_price : selectedService.video_consult_price)
            : null;
        setShowTypePrice(ShowTypePrice);
    }, [selectBtn1]);

    const HandleTimeSelect = (item, dtype) => {
        if (item.o === 0) {
            showToast({ title: t("You cannot book this time"), id: "error" });
        } else if (item.o === 2) {
            showToast({ title: t("This time is already book"), id: "error" });
        } else {
            if (timeSelect === item.t) {
                setTimeSelect("");
                setShowTypePrice("");
            } else {
                setTimeSelect(item.t);
                setSelectHospitalId(item.hid);
                setDateType(dtype);
                const selectedService = service.find(item => item.id === serviceid.id);
                const ShowTypePrice = selectedService
                    ? (selectBtn1 === 0 ? selectedService.client_visit_price : selectedService.video_consult_price)
                    : null;
                setShowTypePrice(ShowTypePrice);
            }
        }
    }

    const HandleDateSelect = (date) => {

        setDateSelect(date);
        setTimeLoading(true);

        axios.post(`${ApiBaseUrl}/customer/doctor_appoint_slot`, { d_id: id, date: date, hospital_id: serviceid?.hospital_id, department_id: serviceid?.department_id })
            .then((res) => {
                const { ndatelist } = res.data;
                setTimeList(ndatelist);
                setTimeLoading(false);
                setTimeSelect("");
                setShowTypePrice("");
            })
            .catch((error) => {
                console.error(error);
            })
    }

    const HandleBookAppoint = () => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (!timeSelect) {
            showToast({ title: t("Select time for your appointment!"), id: "error" });
            return;
        }

        const Data = {
            Docid: id,
            subdeparid: serviceid.id,
            HospitalId: selectHospitalId,
            DepartmentId: department_id,
            showtitle: selectBtn1 === 0 ? "In Person Appointment" : "Video Visit Appointment",
            Date: dateSelect,
            datetype: dateType,
            time: timeSelect,
            show_type: selectBtn1 === 0 ? "1" : "2",
            showtypeprice: showTypePrice,
            commission: doctorData?.commission,
        }

        if (!Userid) {
            setIsShow(false);
            setIsLoginShow(true);
            return;
        }

        navigate("/book-appointment", { state: { data: Data } });
    }

    const HandleAddFavorite = (id) => {
        const Userid = secureLocalStorage.getItem("Userid");

        if (Userid) {
            axios.post(`${ApiBaseUrl}/customer/doc_favorite_add_remove`, { id: Userid, d_id: id, department_id: department_id })
                .then((res) => {
                    if (res.data.ResponseCode === 200) {
                        showToast({ title: res.data.message, id: "success" })
                        setIsFav(isFav === 0 ? 1 : 0);
                    }
                })
                .catch((error) => {
                    console.error(error);
                })
        } else {
            setIsLoginShow(true);
        }
    }

    const HandleSelectService = (item) => {
        setServiceId(item);
        setShowType(item.show_type);
        const index = item.show_type === "2" ? 1 : 0;
        setSelectBtn1(index);
    }

    return (
        <div className='width-container docprofile'>
            {loading
                ? <Loading CustomeStyle="fixed left-0 top-0 h-[100vh] w-full flex items-center justify-center bg-white" />
                : <div className="">
                    <div className="mt-[20px] section-1">
                        <div className="flex items-center justify-between top-section">
                            <Link to="/"
                                className="flex items-center gap-[5px] border-[2px] border-gray-200 rounded-[50px] px-[10px] group py-[4px] hover:bg-black">
                                <IoIosArrowBack className=' group-hover:text-white' />
                                <h1 className='font-[500] group-hover:text-white'> {t("Go Home")}</h1>
                            </Link>
                            <div className="flex items-center gap-[10px] max-_430_:hidden">
                                <Link to={path} className='font-[500] text-gray-700'>{t(pagename)}</Link>
                                <IoIosArrowForward />
                                <h1 className='font-[500] text-gray-400'>{title}</h1>
                            </div>
                            <div className="border-[2px] border-gray-200 rounded-[50px] px-[20px] py-[2px] hidden max-_430_:block">
                                <Link to={path} className='font-[500] text-gray-600'>Back</Link>
                            </div>
                        </div>

                        <div className="mt-[20px] relative">
                            <img className='bg-img w-[100%] '
                                src={ImgBaseUrl + doctorData?.cover_logo}
                                alt="Bg Img" />
                            <button onClick={() => HandleAddFavorite(doctorData.id)} className="absolute right-[15px] top-[15px] bg-[#00000048] p-[8px] rounded-[50px]">
                                {isFav === 0
                                    ? <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.765 4.70229L12 5.52422L11.235 4.70229C9.12233 2.43257 5.69709 2.43257 3.58447 4.70229C1.47184 6.972 1.47184 10.6519 3.58447 12.9217L10.4699 20.3191C11.315 21.227 12.685 21.227 13.5301 20.3191L20.4155 12.9217C22.5282 10.6519 22.5282 6.972 20.4155 4.70229C18.3029 2.43257 14.8777 2.43257 12.765 4.70229Z" stroke="white" stroke-width="1.5" stroke-linejoin="round" />
                                    </svg>
                                    : <svg width="24" height="24" viewBox="0 0 24 24" fill="#0d4047" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12.765 4.70229L12 5.52422L11.235 4.70229C9.12233 2.43257 5.69709 2.43257 3.58447 4.70229C1.47184 6.972 1.47184 10.6519 3.58447 12.9217L10.4699 20.3191C11.315 21.227 12.685 21.227 13.5301 20.3191L20.4155 12.9217C22.5282 10.6519 22.5282 6.972 20.4155 4.70229C18.3029 2.43257 14.8777 2.43257 12.765 4.70229Z" stroke="none" stroke-width="1.5" stroke-linejoin="round" />
                                    </svg>}
                            </button>
                        </div>

                        <div ref={AboutRef} className="">
                            <img className='bg-[#A0E1E1] doctor-img'
                                src={ImgBaseUrl + doctorData?.logo}
                                alt="" />
                            <div className="mt-[10px] flex flex-wrap items-center justify-between gap-[20px] padding">
                                <div className="">
                                    <div className="doctor-name flex items-center gap-[10px]">
                                        <h1 className='flex items-center gap-[5px]'>{doctorData?.name}</h1>
                                        {doctorData?.verification_status === "1" && <RiVerifiedBadgeFill className='text-green-500 text-[25px]' />}
                                    </div>
                                    <p className='text-gray-500 font-[500] text-[18px] max-_430_:text-[16px]'>{doctorData?.subtitle}</p>
                                </div>
                                <div className="profile-detail doctor-box">
                                    <div className="flex items-center gap-[10px] max-_995_:gap-[20px] max-_430_:gap-[10px]">
                                        <div className="details-box max-_882_:me-[7px]">
                                            <div className="icon-box">
                                                <img src={briefcaseicon} className='min-w-[25px]' alt="briefcase" />
                                            </div>
                                            <div className="details">
                                                <h1>{t("Total Experience")}</h1>
                                                <span>{doctorData?.year_of_experience}+ Year</span>
                                            </div>
                                        </div>
                                        <div className="profile-line"></div>
                                        <div className="details-box">
                                            <div className="icon-box">
                                                <FaStar className='text-[20px] text-[#28303F]' />
                                            </div>
                                            <div className="details">
                                                <h1>{t("Rating")}</h1>
                                                <span>{doctorData?.avg_star}.0 ({doctorData?.tot_review})</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="profile-line line-none max-_882_:hidden"></div>

                                    <div className="flex items-center gap-[10px] max-_995_:gap-[20px] max-_430_:gap-[10px]">
                                        <div className="details-box">
                                            <div className="icon-box">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="#28303F" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12 11.25C11.3096 11.25 10.75 10.6904 10.75 10C10.75 9.30964 11.3096 8.75 12 8.75C12.6904 8.75 13.25 9.30964 13.25 10C13.25 10.4142 13.5858 10.75 14 10.75C14.4142 10.75 14.75 10.4142 14.75 10C14.75 8.74122 13.9043 7.67998 12.75 7.35352V6.5C12.75 6.08579 12.4142 5.75 12 5.75C11.5858 5.75 11.25 6.08579 11.25 6.5V7.35352C10.0957 7.67998 9.25 8.74122 9.25 10C9.25 11.5188 10.4812 12.75 12 12.75C12.6904 12.75 13.25 13.3096 13.25 14C13.25 14.6904 12.6904 15.25 12 15.25C11.3096 15.25 10.75 14.6904 10.75 14C10.75 13.5858 10.4142 13.25 10 13.25C9.58579 13.25 9.25 13.5858 9.25 14C9.25 15.2588 10.0957 16.32 11.25 16.6465V17.5C11.25 17.9142 11.5858 18.25 12 18.25C12.4142 18.25 12.75 17.9142 12.75 17.5V16.6465C13.9043 16.32 14.75 15.2588 14.75 14C14.75 12.4812 13.5188 11.25 12 11.25Z" />
                                                </svg>
                                            </div>
                                            <div className="details me-[4px]">
                                                <h1>{t("Consultation Fee")}</h1>
                                                <span>{currency}{doctorData?.min_inp_price} - {currency}{doctorData?.max_inp_price}</span>
                                            </div>
                                        </div>
                                        <div className="profile-line"></div>
                                        <div className="details-box">
                                            <div className="icon-box">
                                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M2 8C2 5.79086 3.79086 4 6 4H12C14.2091 4 16 5.79086 16 8V16C16 18.2091 14.2091 20 12 20H6C3.79086 20 2 18.2091 2 16V8ZM13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM18.5409 16.3103L17.5 15.1999V8.79993L18.5409 7.68961C19.781 6.3669 22 7.24442 22 9.05749V14.9424C22 16.7554 19.781 17.633 18.5409 16.3103Z" fill="#28303F" />
                                                </svg>
                                            </div>
                                            <div className="details">
                                                <h1>{t("Video Visit")}</h1>
                                                <span>{currency}{doctorData?.min_vid_price} - {currency}{doctorData?.max_vid_price}</span>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="section-2 padding mt-[25px]">

                        <div className="py-[15px] border-t-[1px] border-gray-300">
                            <h1 className='title'>{t("Doctor Bio")}</h1>
                            <p className='text-gray-500'>{doctorData?.description}</p>
                        </div>

                        <div className=""></div>

                        {reviews.length >= 1 && <div ref={ReviewRef} className="py-[15px] border-t-[1px] border-gray-300 reviews">
                            <h1 className='title'>{t("Reviews")}</h1>
                            {reviews.map((item, index) => {
                                return <div key={index}
                                    className="border-[1px] border-gray-300 py-[10px] px-[20px] rounded-[10px] mb-[8px] mt-[10px]">
                                    <div className="flex items-center justify-between gap-[10px]">
                                        <div className="flex items-center gap-[10px]">
                                            <div className="min-w-[50px] min-h-[50px] bg-gray-100 rounded-[50px] flex items-center justify-center">
                                                <h1 className='font-[500] text-[18px]'>{item.cus_name.split("")[0]}</h1>
                                            </div>
                                            <div className="leading-[20px]">
                                                <h1 className='font-[500]'>{item.cus_name}</h1>
                                                <p className='font-[500] max-_430_:text-[14px]'>{item.hospital_name}</p>
                                                <span className='text-gray-500'>{item.date}</span>
                                            </div>
                                        </div>
                                        <div
                                            className="text-[#0d4047] flex items-center gap-[5px] border-[2px] border-[#0d4047] px-[10px] rounded-[5px]">
                                            <FaStar className='text-[#0d4047]' />
                                            <h1 className='font-[500]'>{item.star_no}</h1>
                                        </div>
                                    </div>
                                    <p className='text-gray-500 mt-[5px]'>{item.review}</p>
                                </div>
                            })}
                        </div>}

                        {awards.length >= 1 && <div ref={AwardsRef} className="py-[15px] border-t-[1px] border-gray-300 awaeds">
                            <h1 className='title'>{t("Awards")}</h1>
                            <div className="slider-container mt-[20px]">
                                <Slider {...settingsawards}>
                                    {awards.map((item, index) => {
                                        return <div key={index} className="awaeds-box">
                                            <img
                                                src={ImgBaseUrl + item.image}
                                                alt="" />
                                            <h1 className=''>{item.title}</h1>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>}

                        {photos.length >= 1 && <div ref={PhotosRef} className="py-[15px] border-t-[1px] border-gray-300 awaeds">
                            <h1 className='title'>{t("Photos")}</h1>
                            <div className="slider-container mt-[20px]">
                                <Slider {...settingsawards}>
                                    {photos.map((item, index) => {
                                        return <div key={index} onClick={() => { setphotosIndex(index); setShowLightBox(true) }} className="cursor-pointer">
                                            <img className='rounded-[10px] w-[100%] h-[200px] object-cover'
                                                src={item.src}
                                                alt="" />
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>}

                        {faqList.length >= 1 && <div ref={FAQRef} className="py-[15px] border-t-[1px] border-gray-300">
                            <h1 className='title'>{t("FAQs")}</h1>
                            <div className="mt-[25px]">
                                {faqList.map((item, index) => {
                                    return (
                                        <div key={index} className="mb-[8px]">
                                            <Accordion style={{
                                                border: '1px solid #8080803b', borderRadius: "20px", padding: "10px 0"
                                            }} expanded={expandedIndex === index} onChange={() => handleChange(index)}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls={`panel${index}-content`}
                                                    id={`panel${index}-header`}
                                                >
                                                    <Typography className='max-_430_:text-[14px]' component="span">{item.title}</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails className='max-_430_:text-[14px]'>{item.description}</AccordionDetails>
                                            </Accordion>
                                        </div>
                                    );
                                })}
                            </div>
                        </div>}

                        {doctorData?.cancel_policy && <div ref={CancelPolicyRef} className="py-[15px] border-t-[1px] border-gray-300 mb-[20px]">
                            <h1 className='title'>{t("Cancel Policy")}</h1>
                            <p className='text-gray-500'>{doctorData?.cancel_policy}</p>
                        </div>}
                    </div>

                    <div style={{ zIndex: "888" }} className="bottom-button">
                        <button onClick={() => setIsShow(true)} className='book-btn'>{t("Book Appointment")}</button>
                        <div className="btn">
                            <button className={selectBtn === 1 && "active"} onClick={() => scrollToSection(1, AboutRef)}>{t("About")}</button>
                            {reviews.length >= 1 && <button className={selectBtn === 2 && "active"} onClick={() => scrollToSection(2, ReviewRef)}>{t("Review")}</button>}
                            {awards.length >= 1 && <button className={selectBtn === 3 && "active"} onClick={() => scrollToSection(3, AwardsRef)}>{t("Awards")}</button>}
                            {photos.length >= 1 && <button className={selectBtn === 4 && "active"} onClick={() => scrollToSection(4, PhotosRef)}>{t("Photos")}</button>}
                            {faqList.length >= 1 && <button className={selectBtn === 5 && "active"} onClick={() => scrollToSection(5, FAQRef)}>{t("FAQs")}</button>}
                            {doctorData?.cancel_policy && <button className={selectBtn === 6 && "active"} onClick={() => scrollToSection(6, CancelPolicyRef)}>{t("Cancel Policy")}</button>}
                        </div>
                    </div>


                </div>}

            {isShow && <div onClick={() => setIsShow(false)} className='flex bg-[#00000069] h-full justify-center w-full fixed items-end left-0 top-0 z-[999]'>
                <div onClick={(e) => e.stopPropagation()} className="book-box">
                    <div className="px-[20px] py-[10px]">
                        <div className="bg-gray-100 py-[5px] px-[10px] rounded-[10px]">
                            <h1 className='font-bold text-[20px] max-_430_:text-[18px]'>{t("Service")}</h1>
                            <div className="flex items-center gap-[10px] scroll-container">
                                {service.map((item, index) => {
                                    return <div onClick={() => HandleSelectService(item)} key={index} className={`max-w-[48%] ${serviceid.id === item.id && "border-[1px] border-[#0d4047]"} bg-white px-[10px] py-[5px] rounded-[10px] cursor-pointer my-[10px] flex items-center gap-[5px]`}>
                                        <img src={ImgBaseUrl + item.image} className='w-[30px] h-[30px] min-w-[30px] object-cover rounded-[5px]' alt="" />
                                        <h1 className='font-[500] whitespace-nowrap overflow-hidden overflow-ellipsis max-_430_:text-[14px]'>{item.sub_title}</h1>
                                    </div>
                                })}
                            </div>
                        </div>
                        <div className="bg-gray-100 py-[5px] px-[10px] rounded-[10px] mt-[10px] availability">
                            <h1 className='font-bold text-[20px] max-_430_:text-[18px] mb-[5px]'>{t("Availability")}</h1>
                            <div className="d-flex scroll-container">
                                <div className={`bg-white Select-btn p-[5px] rounded-[50px] flex gap-[20px] ${showType !== "3" && "max-_430_:w-[100%]"}`}>
                                    {(showType === "1" || showType === "3") && <button onClick={() => setSelectBtn1(0)} className={`${selectBtn1 === 0 && "active2"} max-_430_:text-[15px] whitespace-nowrap w-[100%] justify-center`}>
                                        <svg className='duration-[0.3s]' width="24" height="24" viewBox="0 0 24 24" fill={selectBtn1 === 0 ? "#0d4047" : "#28303F"} xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M18 2H6C3.79086 2 2 3.79086 2 6V18C2 19.8642 3.27532 21.4306 5.00111 21.8743C5.32039 21.9563 5.6551 22 6 22H18C18.3449 22 18.6796 21.9563 18.9989 21.8743C20.7247 21.4306 22 19.8642 22 18V6C22 3.79086 20.2091 2 18 2ZM15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12C13.6569 12 15 10.6569 15 9ZM7.15257 17.0155C7.70085 15.2824 9.66322 14 12 14C14.3368 14 16.2991 15.2824 16.8474 17.0155C17.014 17.5421 16.5523 18 16 18H8C7.44772 18 6.98599 17.5421 7.15257 17.0155Z" />
                                        </svg>
                                        {t("In Person")}
                                    </button>}
                                    {(showType === "2" || showType === "3") && <button onClick={() => setSelectBtn1(1)} className={`${selectBtn1 === 1 && "active2"} max-_430_:text-[15px] whitespace-nowrap w-[100%] justify-center`}>
                                        <svg className='duration-[0.3s]' width="24" height="24" viewBox="0 0 24 24" fill={selectBtn1 === 1 ? "#0d4047" : "#28303F"} xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M2 8C2 5.79086 3.79086 4 6 4H12C14.2091 4 16 5.79086 16 8V16C16 18.2091 14.2091 20 12 20H6C3.79086 20 2 18.2091 2 16V8ZM13 9C13 10.1046 12.1046 11 11 11C9.89543 11 9 10.1046 9 9C9 7.89543 9.89543 7 11 7C12.1046 7 13 7.89543 13 9ZM18.5409 16.3103L17.5 15.1999V8.79993L18.5409 7.68961C19.781 6.3669 22 7.24442 22 9.05749V14.9424C22 16.7554 19.781 17.633 18.5409 16.3103Z" />
                                        </svg>
                                        {t("Video Visit")}
                                    </button>}
                                </div>
                            </div>
                            <div className="date-section mt-[10px]">
                                <Slider {...settingsday}>
                                    {dateList?.map((item, index) => {
                                        return <div onClick={() => HandleDateSelect(item.date)} key={index} className={`${dateSelect === item.date && "active"} date-box`}>
                                            <h1 className='font-[500] text-[16px] max-_430_:text-[14px] whitespace-nowrap'>{item.date}</h1>
                                            <span className='font-[500] text-[14px]'>{item.week_day}</span>
                                        </div>
                                    })}
                                </Slider>
                            </div>
                        </div>
                        {!timeLoading
                            ? <div className="">
                                {timeLiat?.Morning.length >= 1 && <div className="bg-gray-100 py-[5px] px-[10px] rounded-[10px] mt-[10px]">
                                    <div className="flex items-center gap-[5px] border-b-[2px] border-white pb-[5px]">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M15 2.25C15.4142 2.25 15.75 2.58579 15.75 3V4C15.75 4.41421 15.4142 4.75 15 4.75C14.5858 4.75 14.25 4.41421 14.25 4V3C14.25 2.58579 14.5858 2.25 15 2.25ZM2 14C2 17.866 5.13401 21 9 21H17C19.7614 21 22 18.7614 22 16C22 13.8639 20.6604 12.0406 18.7755 11.3244C18.2238 11.1148 17.6253 11 17 11C16.4547 11 15.9299 11.0873 15.4386 11.2486C14.7393 9.61449 13.4362 8.30031 11.8097 7.58672C10.9497 7.2094 9.99931 7 9 7C5.13401 7 2 10.134 2 14ZM20.48 5.58049C20.7729 5.2876 20.7729 4.81273 20.48 4.51983C20.1871 4.22694 19.7123 4.22694 19.4194 4.51983L18.7123 5.22694C18.4194 5.51983 18.4194 5.99471 18.7123 6.2876C19.0052 6.58049 19.48 6.58049 19.7729 6.2876L20.48 5.58049ZM22.75 10C22.75 10.4142 22.4142 10.75 22 10.75H21C20.5858 10.75 20.25 10.4142 20.25 10C20.25 9.58579 20.5858 9.25 21 9.25H22C22.4142 9.25 22.75 9.58579 22.75 10ZM15 6C17.1463 6 18.8978 7.69043 18.9957 9.81253C18.3653 9.60932 17.6941 9.5 17 9.5C16.7431 9.5 16.4894 9.51498 16.2396 9.54415C15.4568 8.27448 14.3497 7.22698 13.0331 6.5162C13.6139 6.18758 14.285 6 15 6Z" fill="#eab308" />
                                        </svg>
                                        <h1 className='font-bold text-[20px] max-_430_:text-[18px]'>{t("Morning")}</h1>
                                    </div>
                                    <div className="time-section mt-[10px]">
                                        <div className="slider-container">
                                            <Slider {...settingstime}>
                                                {timeLiat?.Morning.map((item, index) => {
                                                    return <div onClick={() => HandleTimeSelect(item, "Morning")} key={index} className={`${timeSelect === item.t && "select"} ${item.o === 0 && "disabled"} ${item.o === 2 && "deselect"} date-box`}>
                                                        <h1 className='font-[500] text-[16px] max-_430_:text-[14px] whitespace-nowrap'>{item.t.split(" ")[0]}</h1>
                                                        <span className='font-[500] text-[14px]'>{item.t.split(" ")[1]}</span>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>}
                                {timeLiat?.Afternoon.length >= 1 && <div className="bg-gray-100 py-[5px] px-[10px] rounded-[10px] mt-[10px]">
                                    <div className="flex items-center gap-[5px] border-b-[2px] border-white pb-[5px]">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#FF6D00" xmlns="http://www.w3.org/2000/svg">
                                            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.25C12.4142 1.25 12.75 1.58579 12.75 2V3C12.75 3.41421 12.4142 3.75 12 3.75C11.5858 3.75 11.25 3.41421 11.25 3V2C11.25 1.58579 11.5858 1.25 12 1.25ZM18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12ZM12.75 21C12.75 20.5858 12.4142 20.25 12 20.25C11.5858 20.25 11.25 20.5858 11.25 21V22C11.25 22.4142 11.5858 22.75 12 22.75C12.4142 22.75 12.75 22.4142 12.75 22V21ZM19.6014 4.39849C19.8943 4.69139 19.8943 5.16626 19.6014 5.45915L18.8943 6.16626C18.6014 6.45915 18.1265 6.45915 17.8336 6.16626C17.5407 5.87337 17.5407 5.39849 17.8336 5.1056L18.5407 4.39849C18.8336 4.1056 19.3085 4.1056 19.6014 4.39849ZM6.16632 18.8942C6.45921 18.6013 6.45921 18.1264 6.16632 17.8336C5.87342 17.5407 5.39855 17.5407 5.10566 17.8336L4.39855 18.5407C4.10566 18.8336 4.10566 19.3084 4.39855 19.6013C4.69144 19.8942 5.16632 19.8942 5.45921 19.6013L6.16632 18.8942ZM22.75 12C22.75 12.4142 22.4142 12.75 22 12.75H21C20.5858 12.75 20.25 12.4142 20.25 12C20.25 11.5858 20.5858 11.25 21 11.25H22C22.4142 11.25 22.75 11.5858 22.75 12ZM3 12.75C3.41421 12.75 3.75 12.4142 3.75 12C3.75 11.5858 3.41421 11.25 3 11.25H2C1.58579 11.25 1.25 11.5858 1.25 12C1.25 12.4142 1.58579 12.75 2 12.75H3ZM19.6014 19.6014C19.3085 19.8943 18.8336 19.8943 18.5407 19.6014L17.8336 18.8943C17.5407 18.6014 17.5407 18.1265 17.8336 17.8336C18.1265 17.5407 18.6014 17.5407 18.8943 17.8336L19.6014 18.5407C19.8943 18.8336 19.8943 19.3085 19.6014 19.6014ZM5.10566 6.16632C5.39856 6.45921 5.87343 6.45921 6.16633 6.16632C6.45922 5.87342 6.45922 5.39855 6.16633 5.10566L5.45922 4.39855C5.16633 4.10566 4.69145 4.10566 4.39856 4.39855C4.10566 4.69144 4.10566 5.16632 4.39856 5.45921L5.10566 6.16632Z" fill="" />
                                        </svg>

                                        <h1 className='font-bold text-[20px] max-_430_:text-[18px]'>{t("Afternoon")}</h1>
                                    </div>
                                    <div className="time-section mt-[10px]">
                                        <div className="slider-container">
                                            <Slider {...settingstime}>
                                                {timeLiat?.Afternoon.map((item, index) => {
                                                    return <div onClick={() => HandleTimeSelect(item, "Afternoon")} key={index} className={`${timeSelect === item.t && "select"} ${item.o === 0 && "disabled"} ${item.o === 2 && "deselect"} date-box`}>
                                                        <h1 className='font-[500] text-[16px] max-_430_:text-[14px] whitespace-nowrap'>{item.t.split(" ")[0]}</h1>
                                                        <span className='font-[500] text-[14px]'>{item.t.split(" ")[1]}</span>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>}
                                {timeLiat?.Evening.length >= 1 && <div className="bg-gray-100 py-[5px] px-[10px] rounded-[10px] mt-[10px]">
                                    <div className="flex items-center gap-[5px] border-b-[2px] border-white pb-[5px]">
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="#004C98" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M5.67169 14.8685C10.7511 14.8685 14.8687 10.7508 14.8687 5.67144C14.8687 5.0679 14.8106 4.47793 14.6996 3.90684C14.6234 3.51469 14.9857 3.16204 15.3541 3.31639C18.6704 4.70571 21.0001 7.98219 21.0001 11.8028C21.0001 16.8822 16.8824 20.9998 11.803 20.9998C7.98244 20.9998 4.70596 18.6702 3.31664 15.3539C3.16228 14.9854 3.51494 14.6231 3.90708 14.6993C4.47817 14.8103 5.06814 14.8685 5.67169 14.8685Z" />
                                        </svg>

                                        <h1 className='font-bold text-[20px] max-_430_:text-[18px]'>{t("Evening")}</h1>
                                    </div>
                                    <div className="time-section mt-[10px]">
                                        <div className="slider-container">
                                            <Slider {...settingstime}>
                                                {timeLiat?.Evening.map((item, index) => {
                                                    return <div onClick={() => HandleTimeSelect(item, "Evening")} key={index} className={`${timeSelect === item.t && "select"} ${item.o === 0 && "disabled"} ${item.o === 2 && "deselect"} date-box`}>
                                                        <h1 className='font-[500] text-[16px] max-_430_:text-[14px] whitespace-nowrap'>{item.t.split(" ")[0]}</h1>
                                                        <span className='font-[500] text-[14px]'>{item.t.split(" ")[1]}</span>
                                                    </div>
                                                })}
                                            </Slider>
                                        </div>
                                    </div>
                                </div>}
                            </div>
                            : < Loading CustomeStyle="h-[300px] flex items-center justify-center bg-gray-100 rounded-[10px] mt-[10px]" />}
                    </div>
                    {timeSelect !== "" && (
                        <div className="bg-[#0d4047] rounded-t-[10px]">
                            {hospitalList.map((item, index) => {
                                if (item.id === Number(selectHospitalId)) {
                                    return (
                                        <div key={index} className="p-[10px]">
                                            <div className="flex items-center gap-[5px]">
                                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path fill-rule="evenodd" clip-rule="evenodd" d="M15 17V21.25H9V17C9 15.3431 10.3431 14 12 14C13.6569 14 15 15.3431 15 17ZM22 21.25H20V6C20 3.79086 18.2091 2 16 2H8C5.79086 2 4 3.79086 4 6V21.25H2C1.58579 21.25 1.25 21.5858 1.25 22C1.25 22.4142 1.58579 22.75 2 22.75H22C22.4142 22.75 22.75 22.4142 22.75 22C22.75 21.5858 22.4142 21.25 22 21.25ZM12.75 5C12.75 4.58579 12.4142 4.25 12 4.25C11.5858 4.25 11.25 4.58579 11.25 5V7.25H9C8.58579 7.25 8.25 7.58579 8.25 8C8.25 8.41421 8.58579 8.75 9 8.75H11.25V11C11.25 11.4142 11.5858 11.75 12 11.75C12.4142 11.75 12.75 11.4142 12.75 11V8.75H15C15.4142 8.75 15.75 8.41421 15.75 8C15.75 7.58579 15.4142 7.25 15 7.25H12.75V5Z" fill="white" />
                                                </svg>
                                                <h1 className='text-white'>{t("Clinic Details")}</h1>
                                            </div>
                                            <p className='text-white font-[500]'>{item.name}</p>
                                            <span className='text-white font-[500]'>{item.address}</span>
                                        </div>
                                    );
                                }
                            })}
                        </div>
                    )}
                    <div className="rounded-t-[10px] bg-white p-[10px]">
                        <button onClick={HandleBookAppoint} className='book-btn'>{t("Book Appointment")} {showTypePrice && currency + showTypePrice}</button>
                    </div>
                </div>
            </div>}

            <Lightbox
                open={showLightBox}
                close={() => setShowLightBox(false)}
                slides={photos}
                index={photosIndex}
                plugins={[Zoom]}
            />

        </div >
    );
};

export default DocProfile;
/* jshint ignore:end */